// FTEDN Creator — New Post Form (wired to API)
import { useState } from 'react';
import { useCommunityStore } from '../../stores/community.store';
import { useToast } from '../../components/ui/Toast';
import { validatePost } from './community.helpers';
import './NewPostForm.css';

interface NewPostFormProps {
  onClose: () => void;
}

export function NewPostForm({ onClose }: NewPostFormProps) {
  const [content, setContent] = useState('');
  const [type, setType] = useState<'discussion' | 'question'>('discussion');
  const [submitting, setSubmitting] = useState(false);
  const { createPost } = useCommunityStore();
  const { addToast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validation = validatePost(content);
    if (!validation.valid) {
      addToast({ type: 'warning', title: 'Oops', message: validation.error });
      return;
    }

    setSubmitting(true);
    const ok = await createPost(content, type);
    setSubmitting(false);

    if (ok) {
      addToast({ type: 'xp', title: '+20 XP', message: 'Post shared with the community!' });
      onClose();
    } else {
      addToast({ type: 'error', title: 'Error', message: 'Could not create post.' });
    }
  };

  return (
    <div className="new-post-form">
      <form onSubmit={handleSubmit} id="new-post-form">
        <div className="post-type-selector">
          <button type="button" className={`type-btn ${type === 'discussion' ? 'active' : ''}`}
            onClick={() => setType('discussion')}>💬 Discussion</button>
          <button type="button" className={`type-btn ${type === 'question' ? 'active' : ''}`}
            onClick={() => setType('question')}>❓ Question</button>
        </div>
        <textarea className="neo-input post-textarea" placeholder="Share something with the community..."
          value={content} onChange={(e) => setContent(e.target.value)} required id="post-content" />
        <div className="post-char-count">{content.length}/2000</div>
        <div className="new-post-actions">
          <div className="post-attachments">
            <button type="button" className="attach-btn">📷 Photo</button>
            <button type="button" className="attach-btn">🎤 Voice</button>
          </div>
          <div className="post-submit-group">
            <button type="button" className="neo-btn neo-btn--ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="neo-btn neo-btn--primary" id="post-submit" disabled={submitting}>
              {submitting ? 'Posting...' : 'Post'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
